import { useParams } from "react-router-dom";
import { endpointsMetadata } from "../../../../../../common/infrastructure/routes/endpointsMetadata";
import { IGoalsDataSource } from "../../../../../../common/components/goals/models/goalModels";

/**
 * Backs the staff page on a user's profile: points the shared GoalsOverview at the
 * userId-scoped endpoints - the same view the user sees on "Моите цели", plus the editing
 * endpoints.
 */
export const useUserGoalsPage = () => {
  const { id } = useParams();
  const userId = Number(id);

  const dataSource: IGoalsDataSource = {
    listEndpoint: `${endpointsMetadata.goal.getUserGoals}?userId=${userId}`,
    listQueryKey: [endpointsMetadata.goal.getUserGoals, userId],
    setCompletedEndpoint: endpointsMetadata.goal.setUserGoalCompleted,
    editing: {
      userId,
      addEndpoint: endpointsMetadata.goal.addUserGoal,
      editEndpoint: endpointsMetadata.goal.editUserGoal,
      deleteEndpoint: endpointsMetadata.goal.deleteUserGoal,
      reorderEndpoint: endpointsMetadata.goal.reorderUserGoals,
    },
  };

  return { dataSource };
};
